import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const defaultSettings = {
  phone: '919 714 805',
  phone_intl: '+351919714805',
  email: 'info@icardetail.pt',
  address_line1: 'R. 25 de Abril 908',
  address_line2: '4825-026 Agrela',
  address_full: 'R. 25 de Abril 908, 4825-026 Agrela',
  maps_url: 'https://maps.app.goo.gl/GKAp4cLofUewJw63A',
  maps_embed: '',
  instagram_url: '',
  facebook_url: '',
  website: 'icardetail.pt',
  schedule: 'Seg-Sex: 9h-19h | Sáb: 9h-13h'
};

const SettingsContext = createContext({ settings: defaultSettings, refreshSettings: () => {} });

export const useSettings = () => useContext(SettingsContext);

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(defaultSettings);

  const refreshSettings = async () => {
    try {
      const res = await axios.get(`${API_URL}/api/settings`);
      setSettings(res.data);
    } catch (err) {
      console.error('Settings fetch failed:', err);
    }
  };

  useEffect(() => { refreshSettings(); }, []);

  return (
    <SettingsContext.Provider value={{ settings, refreshSettings }}>
      {children}
    </SettingsContext.Provider>
  );
};
